import React, { useEffect, useState } from 'react'
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Breadcrumbs,
    Grid,
    IconButton,
    InputAdornment,
    Link,
    Stack,
    TextField,
    Typography
} from '@mui/material'
import SearchIcon from '../../assets/icons/SearchIcon'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ShortcutRenderer from './ShortcutRenderer'
import IndicatorIcon from '../../assets/icons/indicatorIcon'
import AddAlertIcon from '../../assets/icons/AddAlertIcon'
import Calender from '../../assets/icons/Calender'
import AddSymbol from '../../assets/icons/AddSymbol'
import Chart from '../../assets/icons/Chart'
import Trade from '../../assets/icons/Trade'
import AlarmIcon from '../../assets/icons/AlarmIcon'
import ArrowBackIcon from '../../assets/icons/ArrowBackIcon'
import Screener from '../../assets/icons/Screener'
import Watchlist from '../../assets/icons/watchlist'
import FullScreenIcon from '../../assets/icons/FullScreenIcon'
import RedoIcon from '../../assets/icons/RedoIcon'
import UndoIcon from '../../assets/icons/UndoIcon'
import { CalendarIcon } from '@mui/x-date-pickers'
import Export from '../../assets/icons/Export'
import SplitHorizontalIcon from '../../assets/icons/SplitHorizontalIcon'
import SplitVerticalIcon from '../../assets/icons/SplitVerticalIcon'
import ZoomInIcon from '../../assets/icons/drawingTools/zoomInTool'
import { ZoomOut } from '@mui/icons-material'
import TrendLineIcon from '../../assets/icons/drawingTools/trendLine'
import HorizontalLine from '../../assets/icons/drawingTools/horizontalLine'
import HorizontalRay from '../../assets/icons/drawingTools/horizontalRay'
import VerticalLine from '../../assets/icons/drawingTools/verticalLine'
import Cross from '../../assets/icons/plotTypes/cross'
import CrossLine from '../../assets/icons/drawingTools/crossLine'
import FibonacciIcon from '../../assets/icons/drawingTools/fibonacci'
import RectangleIcon from '../../assets/icons/drawingTools/rectangle'
import CircleIcon from '../../assets/icons/drawingTools/circle'

interface KeyboardShortcutsCategoryViewProps {
    onBackClick: Function;
}

const styles = {
    searchInput: {
        paddingX: '8px',
        borderRadius: '8px',
        border: '1px solid'
    }
}

type ShortcutCategory = 'Chart' | 'Trading' | 'Alerts' | 'Watchlist' | 'Screener' | 'Indicators and drawings';

interface ShortcutData {
    icon: any;
    title: string;
    category: string;
    shortcutName: string;
}

interface CategoryData {
    categoryIcon: any;
    shortcuts: ShortcutData[];
}

const shortcutsData: Record<ShortcutCategory, CategoryData> = {
    Chart: {
        categoryIcon: <Chart sx={{ fontSize: '40px' }} />,
        shortcuts: [
            {
                icon: <AddSymbol fontSize={'small'} />,
                title: 'Quick Search (Symbol)',
                category: 'QUICK_SEARCH',
                shortcutName: 'quickSearch'
            },

            {
                icon: <IndicatorIcon />,
                title: 'Open indicators',
                category: 'Chart',
                shortcutName: 'openIndicatorDialog'
            },
            {
                icon: undefined,
                title: 'Load Chart Layout',
                category: 'Chart',
                shortcutName: 'openMultiPaneMenu'
            },
            {
                icon: undefined,
                title: 'Save Chart Layout',
                category: 'Chart',
                shortcutName: 'saveLayout'
            },
            {
                icon: undefined,
                title: 'Change Symbol',
                category: 'SECURITY_SEARCH',
                shortcutName: 'Any letter key'
            },
            {
                icon: undefined,
                title: 'Change Interval',
                category: 'Chart',
                shortcutName: 'openCustomTimeBucketIntervalDialog'
            },
            {
                icon: undefined,
                title: 'Move chart 1 bar to the left',
                category: 'Chart',
                shortcutName: 'moveChartLeft'
            },
            {
                icon: undefined,
                title: 'Move chart 1 bar to the right',
                category: 'Chart',
                shortcutName: 'moveChartRight'
            },
            {
                icon: undefined,
                title: 'Zoom in',
                category: 'Chart',
                shortcutName: 'zoomIn'
            },
            {
                icon: undefined,
                title: 'Zoom out',
                category: 'Chart',
                shortcutName: 'zoomOut'
            },
            {
                icon: undefined,
                title: 'Move to First Bar',
                category: 'Chart',
                shortcutName: 'moveToFirstBar'
            },
            {
                icon: undefined,
                title: 'Move to Last Bar',
                category: 'Chart',
                shortcutName: 'moveToLastBar'
            },
            {
                icon: undefined,
                title: 'Replay Play/Pause',
                category: 'Chart',
                shortcutName: 'replayPlayPause'
            },
            {
                icon: undefined,
                title: 'Move to Realtime Bar',
                category: 'Chart',
                shortcutName: 'moveToRealtimeBar'
            },
            {
                icon: <UndoIcon />,
                title: 'Undo',
                category: 'Chart',
                shortcutName: 'undo'
            },
            {
                icon: <RedoIcon />,
                title: 'Redo',
                category: 'Chart',
                shortcutName: 'redo'
            },
            {
                icon: undefined,
                title: 'Toggle Maximize Chart',
                category: 'Chart',
                shortcutName: 'toggleMaximizeChart'
            },
            {
                icon: undefined,
                title: 'Toggle Maximize Chart',
                category: 'Chart',
                shortcutName: 'toggleMaximizeChart'
            },

            // {
            //     icon: undefined,
            //     title: 'Replay open/close',
            //     category: 'Chart',
            //     shortcutName: 'openCloseChartReplayDialog'
            // },

            {
                icon: <AddAlertIcon />,
                title: 'Add alert',
                category: 'Chart',
                shortcutName: 'openAlertDialog'
            },
            {
                icon: <Calender fontSize={'small'} />,
                title: 'Go to date',
                category: 'Chart',
                shortcutName: 'openChartDuration'
            },
            {
                icon: <Export />,
                title: 'Save Chart Image',
                category: 'Chart',
                shortcutName: 'saveChartImage'
            },
            {
                icon: undefined,
                title: 'Add Text Note',
                category: 'Chart',
                shortcutName: 'addTextNote'
            },
            {
                icon: undefined,
                title: 'Reset chart view',
                category: 'Chart',
                shortcutName: 'resetChartView'
            },
            {
                icon: <AddSymbol fontSize={'small'} />,
                title: 'Add symbol to active watchlist',
                category: 'Chart',
                shortcutName: 'addToWatchlist'
            },

            {
                icon: undefined,
                title: 'Change chart type',
                category: 'Chart',
                shortcutName: 'openChartTypeMenu'
            },
            {
                icon: <SplitHorizontalIcon />,
                title: 'Split horizontal',
                category: 'Chart',
                shortcutName: 'splitHorizontal'
            },
            {
                icon: <SplitVerticalIcon />,
                title: 'Split vertical',
                category: 'Chart',
                shortcutName: 'splitVertical'
            },
            {
                icon: undefined,
                title: 'Delete current widget',
                category: 'Chart',
                shortcutName: 'deleteCurrentWidget'
            },
            {
                icon: undefined,
                title: 'Pan Left (1 bar)',
                category: 'Chart',
                shortcutName: 'panLeft'
            },
            {
                icon: undefined,
                title: 'Pan Right (1 bar)',
                category: 'Chart',
                shortcutName: 'panRight'
            },
            {
                icon: undefined,
                title: 'Pan Left Fast',
                category: 'Chart',
                shortcutName: 'panLeftFast'
            },
            {
                icon: undefined,
                title: 'Pan Right Fast',
                category: 'Chart',
                shortcutName: 'panRightFast'
            },


            {
                icon: undefined,
                title: 'Scroll to Recent Bar',
                category: 'Chart',
                shortcutName: 'scrollToRecentBar'
            },
            {
                icon: undefined,
                title: 'Replay Step Forward',
                category: 'Chart',
                shortcutName: 'replayStepForward'
            },
            {
                icon: undefined,
                title: 'Switch to Next Chart',
                category: 'Chart',
                shortcutName: 'switchNextChart'
            },
            {
                icon: undefined,
                title: 'Switch to Previous Chart',
                category: 'Chart',
                shortcutName: 'switchPrevChart'
            },
            {
                icon: undefined,
                title: 'Open Keyboard Shortcuts Help',
                category: 'Chart',
                shortcutName: 'openKeyboardShortcutsHelp'
            },
            {
                icon: undefined,
                title: 'Show Plus button on cursor',
                category: 'Chart',
                shortcutName: 'showPlusButtonOnCursor'
            },
            {
                icon: undefined,
                title: 'Open layouts save-menu',
                category: 'SAVE_MENU',
                shortcutName: 'openSaveMenu'
            },
            {
                icon: <FullScreenIcon />,
                title: 'Fullscreen mode',
                category: 'Chart',
                shortcutName: 'showHideFullScreen'
            },

        ]
    },
    Trading: {
        categoryIcon: <Trade sx={{fontSize:'40px'}}/>,
        shortcuts: [
            {
                icon: undefined,
                title: 'Open/close Trade Panel',
                category: 'Trading',
                shortcutName: 'openCloseTradePanel'
            },
            {
                icon: undefined,
                title: 'Place market order to buy',
                category: 'Trading',
                shortcutName: 'placeMarketOrderBuy'
            },
            {
                icon: undefined,
                title: 'Place market order to sell',
                category: 'Trading',
                shortcutName: 'placeMarketOrderSell'
            },
            {
                icon: undefined,
                title: 'Place limit order to buy',
                category: 'Trading',
                shortcutName: 'placeLimitOrderBuy'
            },
            {
                icon: undefined,
                title: 'Place limit order to sell',
                category: 'Trading',
                shortcutName: 'placeLimitOrderSell'
            }
        ]
    },
    Alerts: {
        categoryIcon: <AlarmIcon />,
        shortcuts: [
            {
                icon: <AddAlertIcon />,
                title: 'Create Alert (Open Dialog)',
                category: 'ALERT_DIALOG',
                shortcutName: 'openAlertDialog'
            },

            {
                icon: undefined,
                title: 'Save Changes in Edit Dialog',
                category: 'ALERT_DIALOG',
                shortcutName: 'saveAlertChanges'
            },
            {
                icon: undefined,
                title: 'Next Alert/Event',
                category: 'ALERT_DIALOG',
                shortcutName: 'nextAlert'
            },
            {
                icon: undefined,
                title: 'Previous Alert/Event',
                category: 'ALERT_DIALOG',
                shortcutName: 'previousAlert'
            },
            {
                icon: undefined,
                title: 'Next Alert (Space)',
                category: 'ALERT_DIALOG',
                shortcutName: 'nextAlertSpace'
            },
            {
                icon: undefined,
                title: 'Previous Alert (Space)',
                category: 'ALERT_DIALOG',
                shortcutName: 'previousAlertSpace'
            },
            {
                icon: undefined,
                title: 'Select All Alerts/Events',
                category: 'ALERT_DIALOG',
                shortcutName: 'selectAllAlerts'
            },
            {
                icon: undefined,
                title: 'Select Next Alert/Event',
                category: 'ALERT_DIALOG',
                shortcutName: 'selectNextAlert'
            },
            {
                icon: undefined,
                title: 'Select Previous Alert/Event',
                category: 'ALERT_DIALOG',
                shortcutName: 'selectPreviousAlert'
            },
            {
                icon: undefined,
                title: 'Remove Alert (No Confirmation)',
                category: 'ALERT_DIALOG',
                shortcutName: 'removeAlertNoConfirm'
            }
        ]
    },

    Watchlist: {
        categoryIcon: <Watchlist sx={{ fontSize: '40px' }} />,
        shortcuts: [
            {
                icon: undefined,
                title: 'Add symbol to active watchlist',
                category: 'ADD_TO_WATCHLIST',
                shortcutName: 'addToWatchlist'
            },
            {
                icon: undefined,
                title: 'Change watchlist',
                category: 'WATCHLIST',
                shortcutName: 'changeWatchlist'
            },
            {
                icon: undefined,
                title: 'Next symbol',
                category: 'WATCHLIST',
                shortcutName: 'watchlistNextSymbol'
            },
            {
                icon: undefined,
                title: 'Previous symbol',
                category: 'WATCHLIST',
                shortcutName: 'watchlistPreviousSymbol'
            },
            {
                icon: undefined,
                title: 'Next symbol (Space)',
                category: 'WATCHLIST',
                shortcutName: 'watchlistNextSymbolSpace'
            },
            {
                icon: undefined,
                title: 'Previous symbol (Space)',
                category: 'WATCHLIST',
                shortcutName: 'watchlistPreviousSymbolSpace'
            },
            {
                icon: undefined,
                title: 'Flag/unflag symbol',
                category: 'WATCHLIST',
                shortcutName: 'watchlistFlagUnflagSymbol'
            },
            {
                icon: undefined,
                title: 'Select all symbols',
                category: 'WATCHLIST',
                shortcutName: 'watchlistSelectAllSymbols'
            },
            {
                icon: undefined,
                title: 'Select next symbol',
                category: 'WATCHLIST',
                shortcutName: 'watchlistSelectNextSymbol'
            },
            {
                icon: undefined,
                title: 'Select previous symbol',
                category: 'WATCHLIST',
                shortcutName: 'watchlistSelectPreviousSymbol'
            }
        ]
    },
    Screener: {
        categoryIcon: <Screener sx={{ fontSize: '40px' }} />,
        shortcuts: [
            {
                icon: undefined,
                title: 'Next symbol',
                category: 'SCREENER',
                shortcutName: 'nextSymbol'
            },
            {
                icon: undefined,
                title: 'Previous symbol',
                category: 'SCREENER',
                shortcutName: 'previousSymbol'
            },
            {
                icon: undefined,
                title: 'Flag/unflag symbol',
                category: 'SCREENER',
                shortcutName: 'flagUnflagSymbol'
            },
            {
                icon: undefined,
                title: 'Select all symbols',
                category: 'SCREENER',
                shortcutName: 'selectAllSymbols'
            },
            {
                icon: undefined,
                title: 'Select next symbol',
                category: 'SCREENER',
                shortcutName: 'selectNextSymbol'
            },
            {
                icon: undefined,
                title: 'Select previous symbol',
                category: 'SCREENER',
                shortcutName: 'selectPreviousSymbol'
            },
            {
                icon: undefined,
                title: 'Create new screen',
                category: 'SCREENER',
                shortcutName: 'createNewScreen'
            },
            {
                icon: undefined,
                title: 'Save screen',
                category: 'SCREENER',
                shortcutName: 'saveScreen'
            },
            {
                icon: undefined,
                title: 'Load screen',
                category: 'SCREENER',
                shortcutName: 'loadScreen'
            },
            {
                icon: undefined,
                title: 'Save screen as',
                category: 'SCREENER',
                shortcutName: 'saveAsScreen'
            },
            // {
            //     icon: undefined,
            //     title: 'Add new filter',
            //     category: 'SCREENER',
            //     shortcutName: 'addNewFilter'
            // },
            // {
            //     icon: undefined,
            //     title: 'Add new column',
            //     category: 'SCREENER',
            //     shortcutName: 'addNewColumn'
            // },
            // {
            //     icon: undefined,
            //     title: 'Maximize screener',
            //     category: 'SCREENER',
            //     shortcutName: 'maximizeScreener'
            // },
            // {
            //     icon: undefined,
            //     title: 'Undo',
            //     category: 'SCREENER',
            //     shortcutName: 'undoScreener'
            // },
            // {
            //     icon: undefined,
            //     title: 'Redo',
            //     category: 'SCREENER',
            //     shortcutName: 'redoScreener'
            // },
            // {
            //     icon: undefined,
            //     title: 'Discard changes',
            //     category: 'SCREENER',
            //     shortcutName: 'discardScreenChanges'
            // },
            {
                icon: undefined,
                title: 'Export screen',
                category: 'SCREENER',
                shortcutName: 'exportScreen'
            },
            {
                icon: undefined,
                title: 'Rename screen',
                category: 'SCREENER',
                shortcutName: 'renameScreen'
            }
        ]
    },
    'Indicators and drawings': {
        categoryIcon: <IndicatorIcon  sx={{fontSize:'34px'}}/>,
        shortcuts: [
            // {
            //     icon: undefined,
            //     title: 'Draw with demonstration cursor',
            //     category: 'Indicators and drawings',
            //     shortcutName: 'drawWithDemonstrationCursor'
            // },

            // {
            //     icon: undefined,
            //     title: 'Partially erase',
            //     category: 'Indicators and drawings',
            //     shortcutName: 'partiallyErase'
            // },
            // {
            //     icon: undefined,
            //     title: 'Gann box fixed increments',
            //     category: 'Indicators and drawings',
            //     shortcutName: 'gannBoxFixedIncrements'
            // },
            // {
            //     icon: undefined,
            //     title: 'Measure tool',
            //     category: 'Indicators and drawings',
            //     shortcutName: 'measureTool'
            // },
            {
                icon: undefined,
                title: 'Copy selected object',
                category: 'Indicators and drawings',
                shortcutName: 'copySelectedObject'
            },
            {
                icon: undefined,
                title: 'Paste object',
                category: 'Indicators and drawings',
                shortcutName: 'pasteObject'
            },
            {
                icon: undefined,
                title: 'Remove selected object',
                category: 'Indicators and drawings',
                shortcutName: 'removeObject'
            },
            {
                icon: undefined,
                title: 'Hide all drawings',
                category: 'Indicators and drawings',
                shortcutName: 'hideAllDrawings'
            },
            {
                icon: undefined,
                title: 'Clone a drawing',
                category: 'Indicators and drawings',
                shortcutName: 'cloneDrawing'
            },
            {
                icon: undefined,
                title: 'Drawings multiselect',
                category: 'Indicators and drawings',
                shortcutName: 'drawingsMultiSelect'
            },
            {
                icon: undefined,
                title: 'Move a drawing horizontally or vertically',
                category: 'Indicators and drawings',
                shortcutName: 'moveDrawingHorizontalVertical'
            },
            {
                icon: undefined,
                title: 'Move selected drawing left',
                category: 'Indicators and drawings',
                shortcutName: 'moveDrawingLeft'
            },
            {
                icon: undefined,
                title: 'Move selected drawing right',
                category: 'Indicators and drawings',
                shortcutName: 'moveDrawingRight'
            },
            // {
            //     icon: undefined,
            //     title: 'Move selected drawing up',
            //     category: 'Indicators and drawings',
            //     shortcutName: 'moveDrawingUp'
            // },
            // {
            //     icon: undefined,
            //     title: 'Move selected drawing down',
            //     category: 'Indicators and drawings',
            //     shortcutName: 'moveDrawingDown'
            // },
            {
                icon: <TrendLineIcon />,
                title: 'Trendline',
                category: 'Indicators and drawings',
                shortcutName: 'trendline'
            },
            {
                icon: <HorizontalLine />,
                title: 'Horizontal line',
                category: 'Indicators and drawings',
                shortcutName: 'horizontalLine'
            },
            {
                icon: <HorizontalRay />,
                title: 'Horizontal ray',
                category: 'Indicators and drawings',
                shortcutName: 'horizontalRay'
            },

            {
                icon: <VerticalLine />,
                title: 'Vertical line',
                category: 'Indicators and drawings',
                shortcutName: 'verticalLine'
            },

            {
                icon: <CrossLine />,
                title: 'Cross line',
                category: 'Indicators and drawings',
                shortcutName: 'crossline'
            },
            {
                icon: <FibonacciIcon />,
                title: 'Fib retracement',
                category: 'Indicators and drawings',
                shortcutName: 'fibRetracement'
            },
            {
                icon: <RectangleIcon />,
                title: 'Rectangle',
                category: 'Indicators and drawings',
                shortcutName: 'rectangle'
            },
            {
                icon: <CircleIcon />,
                title: 'Circle',
                category: 'Indicators and drawings',
                shortcutName: 'circle'
            },]

    }
}


export function KeyboardShortcutsCategoryView(props: KeyboardShortcutsCategoryViewProps) {
    const [searchText, setSearchText] = useState('')
    const [filteredResults, setFilteredResults] = useState<any>([])

    useEffect(() => {
        if (!searchText) return

        const filteredResults: Record<ShortcutCategory, ShortcutData[]> = {
            Chart: [],
            Trading: [],
            Alerts: [],
            Watchlist: [],
            Screener: [],
            'Indicators and drawings': []
        }

        for (const category in shortcutsData) {
            const shortcuts = shortcutsData[category as ShortcutCategory].shortcuts
            const matches = shortcuts.filter((item) =>
                item.title.toLowerCase().includes(searchText.toLowerCase())
            )
            if (matches.length > 0) {
                filteredResults[category as ShortcutCategory] = matches
            }
        }
        setFilteredResults(filteredResults)
    }, [searchText])

    return (
        <Grid container sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <Stack gap={2} alignItems={'center'} direction={'row'}>
                <IconButton
                    size="small"
                    sx={{ marginLeft: '-44px' }}
                    onClick={() => {
                        props.onBackClick()
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>
                <Stack gap={2}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link
                            color="inherit"
                            href="#"
                            underline="none"
                            fontSize={14}
                            onClick={() => {
                                props.onBackClick()
                            }}
                        >
                            Knowledge base
                        </Link>
                        <Typography fontSize={14} color="textPrimary">
                            Shortcuts
                        </Typography>
                    </Breadcrumbs>
                    <Typography variant="h5"
                        style={{ fontWeight: '500' }}>Keyboard Shortcuts</Typography>
                </Stack>
            </Stack>
            <TextField
                variant="standard"
                fullWidth
                autoComplete="undefined"
                sx={styles.searchInput}
                placeholder="Find shortcut"
                value={searchText}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                    disableUnderline: true
                }}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setSearchText(event.target.value)
                }}
            />
            <div>
                {searchText ? (
                    Object.keys(filteredResults).map((category) =>
                        filteredResults[category as ShortcutCategory].length > 0 ? (
                            <div key={category}>
                                <Typography color={'textSecondary'} variant="body2" gutterBottom>
                                    {category.toUpperCase()}
                                </Typography>
                                {filteredResults[category as ShortcutCategory].map((item: ShortcutData, index: number) => (
                                    <Stack
                                        key={index}
                                        direction={'row'}
                                        justifyContent={'space-between'}
                                        alignItems={'center'}
                                        marginBottom={2}
                                    >
                                        <Stack gap={2} direction={'row'} alignItems={'center'}>
                                            {item.icon ? <Box padding={'8px'}>
                                                {item.icon}
                                            </Box> : <Box height={'40px'} width={'40px'}></Box>}
                                            <Typography fontSize={'body1'}>{item.title}</Typography>
                                        </Stack>
                                        <ShortcutRenderer shortcutName={item.shortcutName} />
                                    </Stack>
                                ))}
                            </div>
                        ) : null
                    )
                ) : (
                    Object.keys(shortcutsData).map((category) => (
                        <Accordion sx={{
                            backgroundColor: 'none !important',
                            backgroundImage: 'none !important'
                        }} disableGutters={true} key={category}>
                            <AccordionSummary sx={{
                                '&:hover': {
                                    backgroundColor: theme => theme.palette.divider
                                },
                                '&.Mui-expanded': {
                                    backgroundColor: theme => theme.palette.divider
                                }
                            }} expandIcon={<ExpandMoreIcon />}>
                                <Stack alignItems={'center'} gap={2} direction={'row'}>
                                    {shortcutsData[category as ShortcutCategory].categoryIcon}
                                    <Typography fontSize={'18px'}>{category}</Typography>
                                </Stack>
                            </AccordionSummary>
                            <AccordionDetails>
                                {shortcutsData[category as ShortcutCategory].shortcuts.map((item, index) => (
                                    <Stack
                                        key={index}
                                        direction={'row'}
                                        justifyContent={'space-between'}
                                        alignItems={'center'}
                                        marginBottom={2}
                                    >
                                        <Stack gap={2} direction={'row'} alignItems={'center'}>
                                            {item.icon ? <Box padding={'8px'}>
                                                {item.icon}
                                            </Box> : <Box height={'40px'} width={'40px'}></Box>}
                                            <Typography fontSize={'body1'}>{item.title}</Typography>
                                        </Stack>
                                        <ShortcutRenderer shortcutName={item.shortcutName} />
                                    </Stack>
                                ))}
                            </AccordionDetails>
                        </Accordion>
                    ))
                )}
            </div>
        </Grid>
    )
}